module.exports = __webpack_public_path__ + "static/img/sb.da4fbf95.png";